<template>
	<div class="share-list">
		<div v-if="!rows.length" class="text-center grey--text py-6">{{ empty }}</div>
		<div v-for="r in rows" :key="r.key" class="share-row">
			<div class="share-top">
				<img v-if="r.flag" :src="r.flag" alt="" class="share-flag" />
				<v-icon v-else-if="r.icon" small class="mr-1" color="grey darken-1">{{ r.icon }}</v-icon>
				<span class="share-label" :title="r.label">{{ r.label }}</span>
				<span class="share-value">{{ formatNumber(r.value) }}</span>
				<span class="share-pct">{{ formatPct(r.share) }}</span>
				<v-chip x-small label :color="deltaColor(r.delta)" text-color="white" class="share-delta" :title="'prima ' + formatNumber(r.previousValue)">{{ formatDelta(r.delta) }}</v-chip>
			</div>
			<div class="share-bar">
				<span :style="{ width: Math.max(r.share, 1) + '%', background: color }"></span>
			</div>
		</div>
	</div>
</template>

<script>
import { formatNumber, formatPct, formatDelta, deltaColor } from './format';

// elenco "voce · valore · quota · variazione" con barra proporzionale (canali, sorgenti, paesi, dispositivi)
export default {
	name: 'ShareList',
	props: {
		// [{ key, label, value, share, previousValue, delta, icon?, flag? }]
		rows: { type: Array, default: () => [] },
		color: { type: String, default: '#1976D2' },
		empty: { type: String, default: 'Nessun dato nel periodo' },
	},
	methods: { formatNumber, formatPct, formatDelta, deltaColor },
};
</script>

<style scoped>
.share-row + .share-row {
	margin-top: 10px;
}
.share-top {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
}
.share-flag {
	width: 18px;
	height: 13px;
	object-fit: cover;
	border-radius: 2px;
	flex: 0 0 auto;
}
.share-label {
	flex: 1 1 auto;
	min-width: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.share-value {
	font-weight: 600;
	white-space: nowrap;
}
.share-pct {
	width: 48px;
	text-align: right;
	color: rgba(0, 0, 0, 0.55);
	font-size: 12px;
	white-space: nowrap;
}
.share-delta {
	flex: 0 0 auto;
	min-width: 52px;
	justify-content: center;
}
/* telefono: la quota si legge gia' dalla barra, lo spazio va al nome */
@media (max-width: 480px) {
	.share-pct {
		display: none;
	}
}
.share-bar {
	height: 6px;
	background: #eef2f7;
	border-radius: 3px;
	margin-top: 4px;
	overflow: hidden;
}
.share-bar span {
	display: block;
	height: 100%;
	border-radius: 3px;
}
</style>
